<template>
<div id="content">
    <div id="average">平均度數 = {{ average }} kwh</div>
    <div id="chart"></div>
</div>
</template>

<script>
export default {
    name: "FlotBarChart",
    props: ["average", "ymax", "xaxis", "data", "averageData", "tickSize"],
    data() {
        return {
            dataset: '',
            options: '',
        }
    },
    methods: {
        chartUpdate(dataset, options) {
            var p = $.plot($("#chart"), dataset, options);
            this.addLabels(p);
        },
        addLabels(p) {
            // add bar number
            $.each(p.getData()[0].data, function (i, el) {
                var o = p.pointOffset({
                    x: el[0],
                    y: el[1]
                });
                $('<div class="data-point-label">' + el[1] + "</div>")
                    .css({
                        position: "absolute",
                        left: o.left + 5,
                        top: o.top - 20,
                        "font-size": "14px"
                    })
                    .appendTo(p.getPlaceholder())
                    .fadeIn("slow");
            });
        }
    },
    watch: {
        data(newData, oldData) {
            this.dataset[0].data = newData;
            this.chartUpdate(this.dataset, this.options);
        },
        ymax(newMax, oldMax) {
            this.options.yaxes[0].max = newMax;
            this.chartUpdate(this.dataset, this.options);
        },
        averageData(newAverage, oldAverage) {
            this.dataset[1].data = newAverage;
            this.chartUpdate(this.dataset, this.options);
        },
        xaxis(newXAxis, oldXAxis) {
            this.options.xaxis.ticks = newXAxis;
            this.chartUpdate(this.dataset, this.options);
        }
    },
    mounted() {
        var my = this;

        // flot data
        this.dataset = [{
                label: "發電量",
                data: my.data,
                color: "#5482FF",
                yaxis: 1,
                bars: {
                    show: true,
                    showNumbers: true,
                    barWidth: 0.8
                }
            },
            {
                label: "發電量平均",
                data: my.averageData,
                color: "#00ff00",
                lines: {
                    show: true
                },
                align: "center",
                yaxis: 1
            }
        ];

        // flot 設定
        this.options = {
            xaxis: {
                axisLabel: "日期",
                axisLabelUseCanvas: false,
                axisLabelFontSizePixels: 12,
                axisLabelFontFamily: "Verdana, Arial",
                axisLabelPadding: 10,
                ticks: my.xaxis
            },
            yaxes: [{
                axisLabel: "發電度數",
                axisLabelUseCanvas: false,
                axisLabelFontSizePixels: 12,
                axisLabelFontFamily: "Arial",
                axisLabelPadding: 3,
                max: my.ymax,
                autoScale: "none",
                tickSize: my.tickSize,
                tickFormatter: function (v, axis) {
                    return v;
                }
            }],
            legend: {
                noColumns: 0,
                labelBoxBorderColor: "#000000",
                position: "nw"
            },
            grid: {
                hoverable: true,
                borderWidth: 2,
                backgroundColor: {
                    colors: ["#ffffff", "#EDF5FF"]
                },
                margin: 10
            }
        };
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/bar.scss";
</style>
